// extracted by mini-css-extract-plugin
export default {"filter":"Filter_filter__vxThR"};